import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es-mx';

export default function DatePickerGST(props: any) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
      <DemoContainer components={['DatePicker']}>
        <DatePicker label={props.label ? props.label : "Fecha"} {...props} />
      </DemoContainer>
    </LocalizationProvider>
  );
}